import Spinner from "@/common/components/Spinner";
import { cn } from "@/common/utils/cn";
import { createElement } from "react";
import { dashboardChartComponent } from "../../constants/dashboards/dashboardKind.constant";
import useDashboardComponentParsedFilters from "../../hooks/dashboards/useDashboardComponentParsedFilters";
import { useDashboardComponentsPreview } from "../../hooks/dashboards/useDashboardComponentsPreview";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentFiltersProp, DashboardComponentGeneratorData, DashboardComponentKind } from "../../types/dashboards/dashboardComponent.type";

interface DashboardComponentPreviewProps {
  generator: DashboardComponentGeneratorData | undefined;
  kind: DashboardComponentKind | undefined;
  filters?: DashboardComponentFiltersProp;
  dashboardDesiredFilters?: DashboardFilters[];
  ignoreDashboardDesiredFilters?: boolean;
}

const DashboardComponentPreview = ({
  generator,
  kind,
  filters,
  dashboardDesiredFilters,
  ignoreDashboardDesiredFilters,
}: DashboardComponentPreviewProps) => {
  const definitionFilters = generator?.filters ?? {};

  const transformedFilters = useDashboardComponentParsedFilters({
    filters: filters ?? { date: undefined },
    dashboardDesiredFilters: dashboardDesiredFilters || [],
    definitionFilters,
    ignoreDashboardDesiredFilters,
  });

  const {
    data: dashboardComponentPreview,
    isPending: dashboardComponentPreviewIsPending,
  } = useDashboardComponentsPreview({
    filters: {
      generatorKlass: generator?.klass,
      kind,
      filters: transformedFilters,
    },
  });

  if (!generator) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <p className="font-bold">
        Pré-visualização
      </p>

      <div className="bg-white-200 overflow-hidden rounded-lg h-64 flex flex-col">
        <div className="p-4 flex flex-col gap-1">
          <div className="flex items-start justify-between gap-3">
            <div className="flex flex-col">
              <p className="text-white-400 text-sm font-semibold select-none">
                {generator.title}
              </p>

              {generator.subtitle && (
                <p className="text-white-300 text-xs font-semibold select-none">
                  {generator.subtitle}
                </p>
              )}
            </div>
          </div>
        </div>

        <div
          key={`preview-${generator.klass}`}
          className={cn(
            'flex-1 overflow-x-hidden overflow-y-auto',
            (dashboardComponentPreviewIsPending || dashboardComponentPreview?.data?.data?.length === 0) && 'flex items-center justify-center px-4',
          )}
        >
          {dashboardComponentPreviewIsPending ? (
            <Spinner className="fill-white-200 text-white-100" />
          ) : dashboardComponentPreview?.data?.data?.length === 0 ? (
            <p className="text-white-300 italic text-sm text-center">
              Não há dados para serem exibidos
            </p>
          ) : (dashboardComponentPreview?.data?.kind && createElement(
            dashboardChartComponent[dashboardComponentPreview?.data?.kind],
            {
              chartData: dashboardComponentPreview?.data,
              dashboardComponentUpdatedAt: 0,
            },
          ))}
        </div>
      </div>
    </div>
  );
}

export default DashboardComponentPreview;
